import styled from 'styled-components';
import { TaskProps } from '../../services/task';

interface Props {
    name: TaskProps['name'],
    description?: TaskProps['description'],
}

export default function TaskDescription({ name, description }: Props) {

    function cutDescriptionLength(description: string): string {
        const descriptionMaxLength = 60;
        return description.length > descriptionMaxLength ? description.substring(0, descriptionMaxLength - 3) + '...' : description;
    }

    return (
        <Wrapper className="task-container">
            <div className="task-name">{name}</div>
            <div className="task-description">{cutDescriptionLength(description || 'No description')}</div>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    grid-area: description;
    /* background-color: ${props => props.theme.backgroundColor}; */
    /* border-radius: ${props => props.theme.borderRadius}; */
    padding: 0px 8px;
    min-height: 120px;
    display: flex;
    flex-direction: column;

    .task-name {
        font-weight: 700;
        font-size: 14px;
        color: #ffffff;
        padding-top: 16px;
        
    }

    .task-description {
        padding-bottom: 2px;
        padding: 8px 8px 10px 8px; //questionable

        font-size: 12px;
        font-weight: 500;
        color: #eee;
        flex-grow: 1;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    
`